import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogContentText from '@material-ui/core/DialogContentText';

export default function AlertTemplate(props) {
  const { open, title, content, onClose, acceptText, onAccept, rejectText, onReject } = props;
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={() => onClose?.()}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {rejectText && (
          <Button onClick={() => onReject?.()} color="primary">
            {rejectText}
          </Button>
        )}
        {acceptText && (
          <Button onClick={() => onAccept?.()} color="primary">
            {acceptText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
